import { instance as axios } from "../axios";
import JWT from "jsonwebtoken";

import { PRIVATE, PUBLIC } from "../variables";

const TABLE = "/files/";

// initial state
const state = {
  data: {}
};

// getters
const getters = {
  getAll: state => {
    return state.data;
  }
};

// actions
const actions = {
  get({ commit, rootState }) {
    return axios
      .get(TABLE + "folder/get/" + rootState.session.user.codigo)
      .then(res => {
        return decode(res.data.data).then(r => {
          if (r) commit("setData", r);
          else commit("setData", null);
        });
      })
      .catch(err => {
        commit("setData", null);
      });
  },

  clear({ dispatch, rootState }, codigo) {
    return axios
      .get(TABLE + "clear/" + token({ codigo: codigo }))
      .then(res => {
        return !res.data.errors;
      })
      .catch(err => {
        return false;
      });
  },

  download({ commit, rootState }, codigo) {
    return new Promise((resolve, reject) => {
      if (codigo) resolve("client/files/zip/" + token({ codigo: codigo }));
      else resolve(false);
    });
  },

  getByCliente({ commit }, codigo) {
    if (!codigo) return;

    return axios
      .get(TABLE + "folder/get/" + codigo)
      .then(res => {
        return decode(res.data.data).then(r => {
          if (r) commit("setData", r);
          else commit("setData", null);
        });

        return !res.data.errors;
      })
      .catch(err => {
        commit("setData", null);
      });
  },

  upload({ dispatch }, params) {
    let formData = new FormData();
    formData.set("file", params[1]);

    return axios
      .post(TABLE + "upload/" + params[0], formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(res => {
        if (!res.data.errors) {
          return res.data.data;
        } else return false;
      })
      .catch(err => {
        return false;
      });
  },

  delete({ dispatch }, params) {
    return axios
      .post(TABLE + "delete/", params)
      .then(res => {
        if (!res.data.errors) {
          return res.data.data;
        } else return false;
      })
      .catch(err => {
        return false;
      });
  }
};

// mutations
const mutations = {
  setData(state, data) {
    state.data = Object.assign({}, {});
    state.data = data ? data : {};
  }
};

function token(params) {
  return JWT.sign(
    {
      exp: Math.floor(Date.now() / 1000) + 60,
      data: params
    },
    PRIVATE,
    { algorithm: "RS256" }
  );
}

function decode(token) {
  return new Promise(function(resolve, reject) {
    JWT.verify(token, PUBLIC, (err, decoded) => {
      if (err) resolve(false);
      else resolve(JWT.decode(token).data);
    });
  });
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/documentos.js